var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
  var len = len - (s + '').length;
  for (var i = 0; i < len; i++) {
    s = '0' + s;
  }
  return s;
};

/**
 * 获取query值
 */
const getQueryStringByName = name => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  var context = "";
  if (r != null)
    context = r[2];
  reg = null;
  r = null;
  return context == null || context == "" || context == "undefined" ? "" : context;
}
/**
 * 格式化日期
 */
const formatDate = {
  format: function (date, pattern) {
    pattern = pattern || DEFAULT_PATTERN;
    return pattern.replace(SIGN_REGEXP, function ($0) {
      switch ($0.charAt(0)) {
        case 'y':
          return padding(date.getFullYear(), $0.length);
        case 'M':
          return padding(date.getMonth() + 1, $0.length);
        case 'd':
          return padding(date.getDate(), $0.length);
        case 'w':
          return date.getDay() + 1;
        case 'h':
          return padding(date.getHours(), $0.length);
        case 'm':
          return padding(date.getMinutes(), $0.length);
        case 's':
          return padding(date.getSeconds(), $0.length);
      }
    });
  },
  parse: function (dateString, pattern) {
    var matchs1 = pattern.match(SIGN_REGEXP);
    var matchs2 = dateString.match(/(\d)+/g);
    if (matchs1.length == matchs2.length) {
      var _date = new Date(1970, 0, 1);
      for (var i = 0; i < matchs1.length; i++) {
        var _int = parseInt(matchs2[i]);
        var sign = matchs1[i];
        switch (sign.charAt(0)) {
          case 'y':
            _date.setFullYear(_int);
            break;
          case 'M':
            _date.setMonth(_int - 1);
            break;
          case 'd':
            _date.setDate(_int);
            break;
          case 'h':
            _date.setHours(_int);
            break;
          case 'm':
            _date.setMinutes(_int);
            break;
          case 's':
            _date.setSeconds(_int);
            break;
        }
      }
      return _date;
    }
    return null;
  }

}
/**
 * randomWord 产生任意长度随机字母数字组合
 * randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
 */
const randomString = (len, charSet) => {
  charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var randomString = '';
  for (var i = 0; i < len; i++) {
    var randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }
  return randomString;
}

export {
  getQueryStringByName,
  formatDate,
  randomString
}


/**
 * 数组格式转树状结构
 * @param   {array}     array 同级
 * @param   {String}    id 
 * @param   {String}    pid
 * @param   {String}    children
 * @return  {Array}
 */
export const arrayToTree = (array, id = 'id', pid = 'pid', children = 'children') => {
  const data = array.map(item => ({
    ...item
  }))
  const hash = {}
  data.forEach((item, index) => {
    hash[data[index][id]] = data[index]
  })

  const result = []
  data.forEach((item) => {
    const hashVP = hash[item[pid]]
    if (hashVP) {
      !hashVP[children] && (hashVP[children] = [])
      hashVP[children].push(item)
    } else {
      result.push(item)
    }
  })
  //console.log(result)
  return result
}

export const getCurrentMenu = (location, arrayMenu) => {
  if (!!arrayMenu) {
    let current = []
    for (let i = 0; i < arrayMenu.length; i++) {
      const e = arrayMenu[i];
      const child = getCurrentMenu(location, e.children);
      if (!!child && child.length > 0) {
        child.push({
          ...e,
          children: null
        });
        return child;
      }
      if (e.href && pathToRegexp(e.href).exec(location)) {
        current.push({
          ...e,
          children: null
        });
        return current;
      }
    }
    return current;
  }
  return null;
}


/**
 * 判断两个数组是否相等
 * @param {Array} arr1
 * @param {Array} arr2
 */
export const isArraySame = (arr1 = [], arr2 = []) => {
  const _arr1 = [...arr1]
  const _arr2 = [...arr2]
  if (_arr1.length !== _arr2.length) return false;
  if (_arr1.sort().join('') !== _arr2.sort().join('')) return false;

  for (var i = 0, l = _arr1.length; i < l; i++) {
    // Check if we have nested arrays
    if (_arr1[i] instanceof Array && _arr2[i] instanceof Array) {
      // recurse into the nested arrays
      if (!isArraySame(_arr1[i], _arr2[i])) return false;
    } else if (_arr1[i] != _arr2[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/util/util.js